import { render, staticRenderFns } from "./ServiceRequestForm.vue?vue&type=template&id=07fb2822&"
import script from "./ServiceRequestForm.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports